export const companyInfo = {
  name: "LJR Teknik ApS",
  shortName: "LJR Teknik ApS",
  logo: "https://assets.auxodev.dk/assets/ac914a03-55b8-406d-88cf-a09072b72053/4cdafb94-63f9-4079-af03-b7854085fc33.jpg",
  phone: "88 44 38 38",
  emergencyPhone: "88 44 38 38",
  email: "ljr@ljrteknik.dk",
  address: "Klosterbakken 66, 6230 Rødekro",
  cvr: "42547263",
  openingHours: [
    { days: "Mandag - Torsdag", hours: "07:30 - 16:00" },
    { days: "Fredag", hours: "07:30 - 14:30" },
    { days: "Lørdag - Søndag", hours: "Lukket" }
  ],
  features: [
    {
      title: "Hurtig Udrykning",
      description: "Jeg ved, at stilstand koster penge. Min servicevogn er fuldt udstyret til at løse de fleste problemer på stedet.",
      icon: "Zap"
    },
    {
      title: "Professionel Standard",
      description: "Med fokus på kompromisløs kvalitet og præcision sikrer jeg, at alle eftersyn og reparationer lever op til de højeste faglige standarder.",
      icon: "ShieldCheck"
    },
    {
      title: "Mange Års Erfaring",
      description: "Med over 15 års erfaring inden for gaffeltrucks og mindre maskiner garanterer jeg en professionel løsning.",
      icon: "Award"
    },
    {
      title: "Konkurrencedygtige Priser",
      description: "Høj kvalitet behøver ikke koste en formue. Jeg tilbyder gennemskuelige priser og fordelagtige serviceaftaler.",
      icon: "TrendingUp"
    }
  ]
};
